import './style.scss'

import React, { Component } from 'react'

import Icon from 'components/UI/Icon'
import PropTypes from 'prop-types'
import circleIcon from 'img/circle.svg'

class Radio extends Component {
    render() {
        const { className, defaultChecked, onChange, value, id, group, children } = this.props
        return (
            <div className={`radio ${className}`}>
                <input
                    className="radio__input"
                    onChange={(e) => onChange(e)}
                    value={value}
                    id={id}
                    name={group}
                    type="radio"
                    defaultChecked={defaultChecked}
                />
                <label className="radio__label" htmlFor={id}>
                    <Icon className="radio__icon" svg={circleIcon} size="medium" />
                    <span className="radio__text">{children}</span>
                </label>
            </div>
        )
    }
}

Radio.propTypes = {
    onChange: PropTypes.func,
    className: PropTypes.string,
    defaultChecked: PropTypes.bool,
    value: PropTypes.string,
    id: PropTypes.string,
    group: PropTypes.string,
    children: PropTypes.node,
}

export default Radio
